import { render, staticRenderFns } from "./CmsUsp.vue?vue&type=template&id=3549ade1&scoped=true"
import script from "./CmsUsp.vue?vue&type=script&lang=js"
export * from "./CmsUsp.vue?vue&type=script&lang=js"
import style0 from "./CmsUsp.vue?vue&type=style&index=0&id=3549ade1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549ade1",
  null
  
)

export default component.exports